import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";

export type CacheStatus = {
  quotes_at: string | null;
  schedules_at: string | null;
};

// Когда последний раз scheduler обновлял данные. refetchInterval=60s,
// чтобы строка «N мин назад» оставалась честной без шторма запросов.
export function useCacheStatus(): CacheStatus | null {
  const { data } = useQuery({
    queryKey: ["cache-status"],
    queryFn: async ({ signal }) => {
      const { data, error } = await api.GET("/api/cache-status", { signal });
      if (error || !data) throw new Error(String(error ?? "no data"));
      return {
        quotes_at: data.quotes_at ?? null,
        schedules_at: data.schedules_at ?? null,
      };
    },
    refetchInterval: 60_000,
    staleTime: 60_000,
  });
  return data ?? null;
}

// «5 мин назад» / «вчера». Возвращает короткую человеческую строку.
export function ago(iso: string | null): string {
  if (!iso) return "—";
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return "—";
  const mins = Math.floor((Date.now() - t) / 60_000);
  if (mins < 1) return "только что";
  if (mins < 60) return `${mins} мин назад`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} ч назад`;
  const days = Math.floor(hours / 24);
  return `${days} д назад`;
}
